import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientsService } from '../api/clients.service';
import { CLIENTS_KEYS } from './queryKeys';
import type { CreateClientPayload } from '../types';

export function useCreateClient() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (payload: CreateClientPayload) => clientsService.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENTS_KEYS.byOrg(activeOrganizationId!) });
    },
  });
}
